// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_D":"D_csr_pc_D__nTDt8"};